import * as React from "react";
import { ListLine } from "../framework/listLine";
import { IDocumentListParentItem } from "../../models/document/documentListItem";
import { Permission } from "ui/Scripts/source/models/enums";

//DocumentListParentLine
export interface IDocumentListParentLineProp {
    classes?: string;
    companyId: string;
    item: IDocumentListParentItem;
    favorite: boolean;
    onLongPress: (id: string) => void;
    onBackClick: (parentId: string) => void;
    onRemoveFavorite: (id: string, companyId: string) => void;
}

export class DocumentListParentLine extends React.Component<IDocumentListParentLineProp, {}> {
    handleRemoveFavorite = (e) => {
        const props = this.props;
        e.stopPropagation();
        const item = props.item;
        if (!item) return;
        props.onRemoveFavorite(item.id, props.companyId);
    };

    render() {
        const props = this.props;
        const item = props.item;
        const isRoot = item.getIsRoot();
        return (
            <ListLine
                id={item.id}
                first={false}
                selected={false}
                classes={"line parent" + (props.classes ? " " + props.classes : "") + (props.favorite ? " favorite" : "") + (isRoot ? " root" : "")}
                onClick={null}
                onLongPress={props.onLongPress}
                onRefreshList={null}>
                <div className="row">
                    <div className="col col-12">
                        <span className="icon large folder" onClick={!isRoot ? () => { props.onBackClick(item.parentId); } : null}></span>
                        {item.isFolder && item.permission < Permission.Edit &&
                            <span className="icon lock white"></span>
                        }
                        {!isRoot &&
                            <span className="icon return" onClick={() => { props.onBackClick(item.parentId); }}></span>
                        }
                        {props.favorite &&
                            <span className={"icon star full favorite"} onClick={this.handleRemoveFavorite}></span>
                        }
                        <div className="textContainer">
                            <div>{item.code}</div>
                        </div>
                    </div>
                </div>
            </ListLine>
        );
    }
}